<template>
  <server-log-table kind="loginLog" />
</template>

<script>
import ServerLogTable from '../LogPages/ServerLogTable.vue'

export default {
  components: { ServerLogTable },
}
</script>
